import { useQueryClient } from '@tanstack/react-query';
import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import useCustomDataFieldsMutations from 'components/domain/customData/fields/useCustomDataFieldsMutations';
import { CUSTOM_DATA_FIELDS_BASE_QUERY_KEY } from 'components/domain/customData/fields/customDataFieldsQuery';
import useNotify from 'hooks/useNotify';
import { AddCustomFieldFormValues } from './AddCustomField.schema';

const useAddCustomFieldModalFormSubmit = ({ modalId }: { modalId: string }) => {
  const queryClient = useQueryClient();
  const { notifyError } = useNotify();
  const { createCustomField } = useCustomDataFieldsMutations();
  const { closeModal } = useAppModal();
  const { t } = useTranslation();

  const onSubmit = async (values: AddCustomFieldFormValues) => {
    try {
      await createCustomField({
        name: values.name,
        type: values.type,
      });
      closeModal(modalId);
      queryClient.invalidateQueries({
        queryKey: [CUSTOM_DATA_FIELDS_BASE_QUERY_KEY],
      });
    } catch (error) {
      notifyError(t('pageAutomations.customFields.errors.addCustomFieldError'));
    }
  };

  return { onSubmit };
};

export default useAddCustomFieldModalFormSubmit;
